__turbopack_context__.v({
  "article-intro": "ArticleIntro-module-scss-module__3axIPa__article-intro",
});
